import React from "react";

export default function EncryptedEmail(props: any) {

    function UnCryptMailto( s: string )
    {
        var n = 0;
        var r = "";
        for( var i = 0; i < s.length; i++)
        {
            n = s.charCodeAt( i );
            if( n >= 8364 )
            {
                n = 128;
            }
            r += String.fromCharCode( n - 1 );
        }
        return r;
    }

    const linkTo_UnCryptMailto = (s: string) => {
        return () => {
            location.href = UnCryptMailto(s);
        };
    }

    return <>
        {props.type === "contact" &&
        <a className={props.className + ' cursor-pointer'} onClick={linkTo_UnCryptMailto('nbjmup;ifmmpAqbdjgjddpefmjof/dpn')}>
            Send Email</a>}
        {props.type === "jobs" &&
        <a className={props.className+ ' cursor-pointer'} onClick={linkTo_UnCryptMailto('nbjmup;ifmmpAqbdjgjddpefmjof/dpn')}>
            Send Email</a>}
    </>
}
